<template>
  <div id="app">
    <div class="content">
      <nav
        v-if="showNavbar"
        class="navbar navbar-expand-md navbar-dark bg-dark text-white shadow-sm"
      >
        <div class="container">
          <InertiaLink
            class="navbar-brand"
            :href="route(loggedIn ? 'home' : 'marketing')"
          >
            <img src="/images/Clausify_Logo_White.png" class="img-fluid" />
          </InertiaLink>

          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <!-- Left Side Of Navbar -->
            <ul class="navbar-nav mr-auto"></ul>

            <!-- Right Side Of Navbar -->
            <ul class="navbar-nav ml-auto" v-if="loggedIn && clausifyUser">

              <!-- <li class="nav-item">
                <InertiaLink class="nav-link mr-4" :href="route('help')">
                  <Icon
                    icon="help"
                    :width="15"
                    colour="white"
                    class="mr-1"
                  />
                  Help &amp; Advice
                </InertiaLink>
              </li> -->

              <li class="nav-item">
                <InertiaLink
                  class="nav-link mr-4 position-relative"
                  :href="route('todo')"
                >
                  <Icon
                    icon="check"
                    :width="15"
                    colour="white"
                    class="mr-1"
                  />
                  To Do List
                  <span
                    class="bg-danger notification"
                    v-if="$page.props.auth.user.notifications > 0"
                  >
                    <small>{{ $page.props.auth.user.notifications }}</small>
                  </span>
                </InertiaLink>
              </li>

              <li class="nav-item dropdown">
                <a
                  id="navbarDropdown"
                  class="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <Icon
                    icon="account"
                    :width="15"
                    colour="white"
                    class="mr-1"
                  />
                  {{ $page.props.auth.user.first_name }}
                  {{ $page.props.auth.user.last_name }}
                  <span class="caret"></span>
                </a>

                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdown"
                >
                  <a
                    v-if="userHasPermissionTo('view_nova')"
                    class="dropdown-item"
                    href="/nova"
                  >
                    Nova
                  </a>

                  <InertiaLink class="dropdown-item" :href="route('counter-party.index')">
                    Counterparties
                  </InertiaLink>

                  <InertiaLink class="dropdown-item" :href="route('user.profile.index', $page.props.auth.user.id)">
                    User Preferences
                  </InertiaLink>

                  <InertiaLink
                    v-if="userHasPermissionTo('view_organisation')"
                    class="dropdown-item"
                    :href="
                      route(
                        'organisation.show',
                        $page.props.auth.user.organisation.id
                      )
                    "
                    >Organisation
                  </InertiaLink>

                  <InertiaLink
                    class="dropdown-item"
                    :href="route('logout')"
                    method="post"
                    >Logout
                  </InertiaLink>
                </div>
              </li>
            </ul>

            <!-- Right Side Of Navbar -->
            <ul class="navbar-nav ml-auto" v-if="loggedIn && !clausifyUser">
              <li class="nav-item">
                <InertiaLink class="nav-link" :href="route('logout')" method="post">Logout</InertiaLink>
              </li>
            </ul>

            <ul class="navbar-nav ml-auto" v-if="loggedOut">
              <!-- Authentication Links -->
              <li class="nav-item">
                <InertiaLink class="nav-link" :href="route('login')">
                  Login
                </InertiaLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <main>
        <FlashMessages />
        <slot />
      </main>
    </div>

    <footer>
      <nav class="navbar navbar-expand-md navbar-light bg-white">
        <div class="container">
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <!-- Left Side Of Navbar -->
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">Copyright &copy; {{ year }} Clausify Ltd. All rights reserved.</li>
            </ul>

            <!-- Right Side Of Navbar -->
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <InertiaLink class="nav-link mr-2" :href="route('privacy')">
                  Privacy Policy
                </InertiaLink>
              </li>
              <li class="nav-item">
                <InertiaLink class="nav-link mr-2" :href="route('terms')">
                  Terms &amp; Conditions
                </InertiaLink>
              </li>
              <li class="nav-item">
                <a href class="nav-link mr-2" href="https://www.clausify.co/about-us">About Us</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </footer>
  </div>
</template>

<script>
import Helpers from '@/Mixins/helpers';
import FlashMessages from '@/Shared/FlashMessages';
import Icon from '@/Icons/Icon';

export default {

  mixins: [Helpers],

  components: {
    Icon,
    FlashMessages,
  },

  props: {
    title: String,
    navbar: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      showNavbar: this.navbar,
    };
  },

  computed: {
    year() {
      const dt = new Date();
      return dt.getFullYear();
    },

    loggedIn() {
      return this.$page.props.auth.user;
    },

    clausifyUser() {
      return this.$page.props.auth.user.type === 'clausify';
    },

    loggedOut() {
      return !this.$page.props.auth.user;
    },
  },

  watch: {
    title: {
      immediate: true,
      handler(title) {
        document.title = title ? `${title} | Claus.ify` : 'Claus.ify';
      },
    },
  },
};
</script>
